module.exports = __webpack_public_path__ + "img/facebook.892e613d.png";